// eslint-disable-next-line unused-imports/no-unused-vars
export const themeTokensGQLFields = (fields) => `
  breakpoints {
    key
    value
  }
  colors {
    key
    value
  }
  fontSizes {
    key
    value
  }
  fontWeights {
    key
    value
  }
  fontWeights {
    key
    value
  }
  opacity {
    key
    value
  }
  shadows {
    key
    value
  }
  sizes {
    key
    value
  }
  textStyles {
    key
    value
  }
  zIndices {
    key
    value
  }
`;
//# sourceMappingURL=themeTokens.fields.js.map